import styles from './IntroBlockHighlights.module.scss'
import travelHighlightObject from '@/entities/travelHighlight/interface'
import { useTranslation } from 'next-i18next'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

export interface IntroBlockHighlightsProps {
  highlights: travelHighlightObject[]
}
const IntroBlockHighlights = ({ highlights }: IntroBlockHighlightsProps) => {
  const { t } = useTranslation('common')

  return (
    <Row className={styles.root}>
      <Col className={styles.inner}>
        <div className={styles.title}>{t('travel.highlights')}</div>
        {highlights.map((highlight: travelHighlightObject, index: number) => {
          return (
            <ul className={styles.list} key={index}>
              <li>{highlight.text}</li>
            </ul>
          )
        })}
      </Col>
    </Row>
  )
}

export default IntroBlockHighlights
